import React from "react";
import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';




export const CustomDialog = ({
    isOpened=false,
    title="",
    content=null,
    actions=[],
    otherProps={}
})=>{

    
    return (
    <Dialog
    open={isOpened}
    {...otherProps}
    >

        <DialogTitle fontSize={'1.2rem'} >
            {title}
        </DialogTitle>
        {
            React.isValidElement(content)? 
            <DialogContent  >
            {content}
            </DialogContent>:
            <DialogContent dangerouslySetInnerHTML={{__html:!React.isValidElement(content)?content:''}} />
                  
                   

        }

        <DialogActions>
            {
                actions?.map( (action,index)=><LoadingButton
                key={index}
                {...action.buttomProps}
                >{action.title}</LoadingButton>)
            }
        </DialogActions>

    </Dialog>)

}